import { useAccountTemplateLibrary } from './useIndicatorTemplateLibrary.js'
import { readServerChartPreference } from '../lib/chart/chartPreferenceStore.js'
import { normalizeTemplates } from '../components/chart/relativeStrength/AnnotationPrimitive.js'

export const DRAWING_TEMPLATE_SCOPE = 'drawing-template-library-production-v1'
export function useDrawingTemplateLibrary(userId) {
  const library = useAccountTemplateLibrary(userId, DRAWING_TEMPLATE_SCOPE, async () => {
    const saved = await readServerChartPreference({
      userId, scope: 'relative-strength-drawings', preferenceKey: 'templates', throwOnError: true,
    })
    if (saved && (saved.version !== 1 || !Array.isArray(saved.items))) throw Error('Invalid drawing templates')
    return (saved?.items || []).flatMap(item => normalizeTemplates([item])).map(template => ({ ...template, params: {} }))
  })
  return {
    items: library.templates, status: library.status, retry: library.retry,
    save: (kind, name, style) => library.save({ kind, params: {}, style }, name),
  }
}
